import React, {useState} from "react";
import AppColors from './../colors/AppColors';
import {useWindowSize} from "react-use";
import AppIcon from "../views/AppIcon";
import {
    CardContent,
    Card,
    Typography,
    TextField,
    Button,
    useMediaQuery,
    InputLabel,
    OutlinedInput,
    FormControl,
    InputAdornment,
    IconButton,
    CircularProgress
} from "@material-ui/core";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Strings from './../lang/Strings';
import {useOnBoarderStyle} from '../styles/OnBoarderSlideStyles';
import {Link, Redirect} from "react-router-dom";
import Routes from './../constants/Routes';
import {useWelcomeStyle} from '../styles/WelcomeStyle';
import {useTheme} from '@material-ui/core/styles';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import {LoginState} from "../enums/AuthState";
import MaterialSnackBar from "../views/MaterialSnackBar";
import {Validator} from '../utils/Validator';
import {useCookies} from "react-cookie";
import {Constants} from '../constants/Constants';
import EndPoints from "../net/EndPoints";
import axios from "axios";
import UsersManager from "../managers/UsersManager";
import {useDispatch} from "react-redux";
import clsx from "clsx";

export default function LoginView(props: any) {

    const onBoarderClasses = useOnBoarderStyle();
    const welcomeClasses = useWelcomeStyle();
    const {width, height} = useWindowSize();
    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down(800));
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState<string | null>("");
    const [password, setPassword] = useState<string | null>("");
    const [loginState, setLoginState] = useState(LoginState.IDLE);
    const [loggedIn, setLoggedIn] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackSeverity, setSnackSeverity] = useState("warning");
    const [cookies, _] = useCookies([Constants.ACTIVE_OPERATION_STATUS]);
    const dispatch = useDispatch();

    const handleRememberMeChange = (event: any) => {
        setRememberMe(event.target.checked);
    };

    const handleSnackClose = () => {
        setOpenSnack(false);
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    }

    const handleEmailChange = (newValue: string | null) => {
        setEmail(newValue);
    }

    const handlePasswordChange = (newValue: string | null) => {
        setPassword(newValue);
    }

    const handleKeyEvent = (event: KeyboardEvent) => {
        if (event.keyCode === 13) {
            logInUser();
        }
    }

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    }

    const snackError = (message: string) => {
        setSnackMessage(message);
        setSnackSeverity("error");
        setOpenSnack(true);
    }

    const logInUser = () => {
        if (email?.length !== 0 && password?.length !== 0) {
            if (Validator.isEmailValid(email as string)) {
                setLoginState(LoginState.STARTED);
                let logInData = {
                    email: email!! as string,
                    password: password!! as string
                };
                axios.post(EndPoints.LOGIN, logInData)
                    .then(data => {
                        let userData = data["data"]["data"];
                        userData[Constants.REMEMBER_ME] = rememberMe;
                        UsersManager.saveLoggedInUser(JSON.stringify(userData));
                        dispatch({
                            type: Constants.LOGGED_IN_USER_DATA_CHANGED,
                            payload: JSON.stringify(userData)
                        });
                        setLoggedIn(true);
                    }).catch(error => {
                    let errorResponseData = error.response["data"]
                    let message = errorResponseData["message"] ?? "Error completing log in. Please try again";
                    setLoginState(LoginState.IDLE)
                    snackError(message);
                });
            } else {
                snackError("Invalid email provided");
            }
        } else {
            snackError("Please provide all fields");
        }
    }

    return (
        loggedIn ?
            <Redirect to={Routes.HOME}/>
            :
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    background: `url(${require('./../images/wallet_background.png')})`,
                    backgroundColor: '#121d33e1',
                    backgroundRepeat: 'none',
                    backgroundSize: 'cover'
                }}>
                <AppBar position="static"
                        elevation={0}
                        style={{
                            background: 'none'
                        }}>
                    <Toolbar>
                        <AppIcon/>
                    </Toolbar>
                </AppBar>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: height
                }}>
                    <Card
                        style={{
                            width: mobileView ? width - 30 : width / 2,
                            borderRadius: 10,
                        }}>
                        <CardContent
                            style={{
                                margin: 30
                            }}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                <Typography
                                    style={{
                                        fontWeight: 600,
                                        alignSelf: 'flex-start',
                                        fontSize: 20
                                    }}>Welcome!</Typography>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    disabled={loginState === LoginState.STARTED}
                                    id="email"
                                    label="Email Address"
                                    name="email"
                                    value={email}
                                    onChange={(event) => {
                                        handleEmailChange(event.target.value)
                                    }}
                                    onKeyDown={(event) => {
                                        handleKeyEvent(event as unknown as KeyboardEvent)
                                    }}
                                    autoComplete="email"
                                    className={welcomeClasses.fullScreenAuthFields}
                                    style={{
                                        marginTop: 30,
                                        fontWeight: 600,
                                    }}
                                />
                                <FormControl
                                    margin="normal"
                                    fullWidth
                                    disabled={loginState === LoginState.STARTED}
                                    classes={{root: welcomeClasses.fullScreenAuthFields}}
                                    variant="outlined">
                                    <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                                    <OutlinedInput
                                        autoComplete="current-password"
                                        id="outlined-adornment-password"
                                        name="password"
                                        type={showPassword ? 'text' : 'password'}
                                        value={password}
                                        onChange={(event) => {
                                            handlePasswordChange(event.target.value)
                                        }}
                                        onKeyDown={(event) => {
                                            handleKeyEvent(event as unknown as KeyboardEvent)
                                        }}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                    tabIndex="-1"
                                                    style={{
                                                        color: AppColors.BLACK
                                                    }}
                                                    disableFocusRipple
                                                >{showPassword ? <Visibility fontSize={"small"}/> :
                                                    <VisibilityOff fontSize={"small"}/>}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        labelWidth={70}
                                    />
                                </FormControl>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            onChange={handleRememberMeChange}
                                            value="remember"
                                            className={onBoarderClasses.rememberMeCheckStyle}
                                            checkedIcon={<span className={clsx(onBoarderClasses.orangeChecked)}/>}
                                        />
                                    }
                                    label="Remember me"
                                    classes={{
                                        label: onBoarderClasses.rememberMeLabelStyle
                                    }}
                                    style={{
                                        alignSelf: 'flex-start'
                                    }}
                                />
                                <Button onClick={logInUser}
                                        className={mobileView ? onBoarderClasses.getStartedButtonSmall : onBoarderClasses.getStartedButton}
                                        style={{
                                            width: '100%',
                                            marginTop: 10,
                                            fontSize: mobileView ? 13 : 20,
                                        }}
                                        disabled={email?.length === 0 || password?.length === 0 || loginState === LoginState.STARTED}>{loginState === LoginState.STARTED ? Strings.PLEASE_WAIT : Strings.LOGIN_TEXT}
                                    {
                                        loginState === LoginState.STARTED &&
                                        <CircularProgress color="inherit" size={20}
                                                          style={{
                                                              marginLeft: 10,
                                                              color: AppColors.ACCENT_COLOR
                                                          }}/>
                                    }
                                </Button>
                                <Link style={{
                                    alignSelf: 'flex-end',
                                    marginTop: 10,
                                    textDecoration: 'none',
                                    fontWeight: 600,
                                    fontSize: 12,
                                    color: AppColors.BLUE
                                }} to={Routes.PASSWORD_RECOVERY}>Forgot Password?</Link>
                            </div>
                        </CardContent>
                    </Card>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'row',
                        alignItems: 'center',
                        marginTop: 10
                    }}>
                        <Typography style={{
                            color: AppColors.GREY_TEXT,
                            fontWeight: 600,
                            fontSize: 15,
                        }}>Don't have an account?</Typography>
                        <Link to={Routes.SIGN_UP}
                              style={{
                                  color: AppColors.WHITE,
                                  fontWeight: 600,
                                  marginLeft: 5,
                                  fontSize: 14,
                                  textDecoration: 'none'
                              }}>{Strings.SIGNUP_TEXT}
                        </Link>
                    </div>
                </div>
                <MaterialSnackBar open={openSnack} onSnackClosed={handleSnackClose} message={snackMessage}
                                  severity={snackSeverity}/>
            </div>
    );
}
